import { useEffect, useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { tryCatchHandlr } from "@shared/Utilities";

import { ListCheckRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../shared";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import PipedElements from "../PipedElements";

const NewTaskActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");
  const [personUuid, setPersonUuid] = useState(null);

  useEffect(() => {
    (async () => {
      if (activity.data?.taskId) {
        const [res, err] = await tryCatchHandlr(
          caseTransformingAxios.get(`/api/v3/tasks/${activity.data?.taskId}`),
        );

        if (err) {
          return;
        }

        setPersonUuid(res.data?.task?.taskableId);
      }
    })();
  }, []);

  return (
    <ActivityContainer
      activity={{ ...activity, personUuid }}
      queryParams={queryParams.toString()}
      onReadChange={onReadChange}
    >
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]" Icon={ListCheckRegularV6}>
            New Task
          </CategoryContainer>
        }
        personName={`${activity.data?.assigneeName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <span className={STYLES.lineClamp3}>{activity.data?.taskTitle}</span>
        <DataField label="Type" data={activity.data?.taskType} />
        <PipedElements>
          <DataField label="Due" data={activity.data?.taskDueDate} />
          <DataField label="From" data={activity.data?.assignerName} />
        </PipedElements>
      </div>
    </ActivityContainer>
  );
};

export default NewTaskActivity;

NewTaskActivity.propTypes = {
  ...activityCommonPropTypes,
};

NewTaskActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
